export default [
            {
                path: '/manage-id-cards',
                name: 'manage-id-cards',
                component: () => import('./ManageIDCards.vue'),
            },
         
   
]